import { Checkbox, Grid, Group, Modal, ModalProps, Textarea } from '@mantine/core';

import { IPageData } from 'pages/contact';
import InputLabel from './InputLabel';

interface IPrivacyPolicyModal extends ModalProps, IPageData {}

const PrivacyPolicyModal = ({
  form,
  isMobile,
  onClose,
  opened,
  t,
}: IPrivacyPolicyModal) => {

  return (
    <Modal opened={opened} onClose={onClose} size={isMobile ? '90%' : '50%'}>
      <Grid columns={isMobile ? 1 : 12}>
        <Grid.Col span={isMobile ? 1 : 12}>
          <Textarea
            rows={20}
            readOnly
            styles={{ input: { fontSize: '11px', borderWidth: 0 } }}
            defaultValue={t('privacy.policy.text')}
          />
        </Grid.Col>
        <Grid.Col span={isMobile ? 1 : 12}>
          <Checkbox
            color={'#62AF45'}
            label={(
              <Group gap={4}>
                <InputLabel label={t('privacy.policy.accept.0')} />
                <InputLabel label={t('privacy.policy.accept.1')} />
                <InputLabel label={t('privacy.policy.accept.2')} />
              </Group>
            )}
            checked={form.values.privacyPolicy}
            onChange={(event) => form.setFieldValue('privacyPolicy', event.currentTarget.checked)}
          />
        </Grid.Col>
      </Grid>
    </Modal>
  )
}

export default PrivacyPolicyModal;